import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14","key":"svg-0"}],["path",{"d":"M11.5 12a.5 .5 0 1 0 1 0a.5 .5 0 1 0 -1 0","fill":"currentColor","key":"svg-1"}]]

const IconDice1 = createReactComponent('outline', 'dice-1', 'Dice1', __iconNode);

export default IconDice1;